export default __webpack_public_path__ + "static/media/pro-elevate-red-1.16985464.png";